export const LISTING_STATE_DRAFT = 'draft';
export const LISTING_STATE_PUBLISHED = 'published';

export const LISTING_CATEGORY_FILTER = 'publicData.listingType';

// filter attributes
export const PRICE_AMOUNT_FILTER = 'price';
export const RATING_FILTER = 'averageRating';
export const PRIMARY_DESTINATIONS_FILTER = 'publicData.destinationCountries.name';
export const PRIMARY_SERVICES_FILTER = 'publicData.services';
export const PRIMARY_RESIDENCE_FILTER = 'publicData.countryOfResidence';
export const LANGUAGES_FILTER = 'publicData.languages';
export const LANGUAGES_FLUENCY_FILTER = 'publicData.languagesFluency';
export const SECONDARY_DESTINATIONS_FILTER = 'publicData.subDestinations.regionFilter';

// filter types
export const FILTER_TYPE_REFINEMENT_LIST = 'refinementList';
export const FILTER_TYPE_MENU = 'menuList';
export const FILTER_RANGE_INPUT = 'range';

export const listingFilters = [
  { attribute: PRIMARY_DESTINATIONS_FILTER, label: "Countries", type: FILTER_TYPE_REFINEMENT_LIST },
  { attribute: LANGUAGES_FILTER, label: "Languages", type: FILTER_TYPE_REFINEMENT_LIST },
  { attribute: PRIMARY_SERVICES_FILTER, label: "Services", type: FILTER_TYPE_REFINEMENT_LIST },
  { attribute: PRICE_AMOUNT_FILTER, label: "Price", type: FILTER_RANGE_INPUT },
  { attribute: RATING_FILTER, label: "Rating", type: FILTER_TYPE_REFINEMENT_LIST },
];

export const LISTING_SEARCH_ID = 'listing';

export const SEARCHABLE_LISTING_ATTRIBUTES = [
  'listingType',
  'countryOfResidence',
  'destinations',
  'destinationCountries',
  'destinationRegions',
  'languages',
  'price',
  'services',
  'subDestinations'
];

// Algolia events
export const QUERY_SUBMITTED = 'query submitted';

export const REGION_MAP_SECTION = 'region_map';
export const REGION_MAP_BLOCK = 'region-map-container';

export const countryToContinentMap = {
  "AF": "Asia",
  "AX": "Europe",
  "AL": "Europe",
  "DZ": "Africa",
  "AS": "Oceania",
  "AD": "Europe",
  "AO": "Africa",
  "AI": "North America",
  "AQ": "Antarctica",
  "AG": "North America",
  "AR": "South America",
  "AM": "Asia",
  "AW": "North America",
  "AU": "Oceania",
  "AT": "Europe",
  "AZ": "Asia",
  "BS": "North America",
  "BH": "Asia",
  "BD": "Asia",
  "BB": "North America",
  "BY": "Europe",
  "BE": "Europe",
  "BZ": "North America",
  "BJ": "Africa",
  "BM": "North America",
  "BT": "Asia",
  "BO": "South America",
  "BQ": "North America",
  "BA": "Europe",
  "BW": "Africa",
  "BV": "Antarctica",
  "BR": "South America",
  "IO": "Asia", // British Indian Ocean Territory
  "BN": "Asia",
  "BG": "Europe",
  "BF": "Africa",
  "BI": "Africa",
  "CV": "Africa",
  "KH": "Asia",
  "CM": "Africa",
  "CA": "North America",
  "KY": "North America",
  "CF": "Africa",
  "TD": "Africa",
  "CL": "South America",
  "CN": "Asia",
  "CX": "Oceania", // Christmas Island (Australian territory)
  "CC": "Oceania", // Cocos (Keeling) Islands (Australian territory)
  "CO": "South America",
  "KM": "Africa",
  "CG": "Africa",
  "CD": "Africa",
  "CK": "Oceania",
  "CR": "North America",
  "CI": "Africa",
  "HR": "Europe",
  "CU": "North America",
  "CW": "North America",
  "CY": "Asia", // Some sources list Cyprus as Europe; adjust if needed
  "CZ": "Europe",
  "DK": "Europe",
  "DJ": "Africa",
  "DM": "North America",
  "DO": "North America",
  "EC": "South America",
  "EG": "Africa",
  "SV": "North America",
  "GQ": "Africa",
  "ER": "Africa",
  "EE": "Europe",
  "SZ": "Africa", // Eswatini (formerly Swaziland)
  "ET": "Africa",
  "FK": "South America", // Falkland Islands
  "FO": "Europe",
  "FJ": "Oceania",
  "FI": "Europe",
  "FR": "Europe",
  "GF": "South America",
  "PF": "Oceania",
  "TF": "Antarctica",
  "GA": "Africa",
  "GM": "Africa",
  "GE": "Asia", // Some classifications may list Georgia in Europe
  "DE": "Europe",
  "GH": "Africa",
  "GI": "Europe",
  "GR": "Europe",
  "GL": "North America", // Greenland is geographically part of North America
  "GD": "North America",
  "GP": "North America",
  "GU": "Oceania",
  "GT": "North America",
  "GG": "Europe",
  "GN": "Africa",
  "GW": "Africa",
  "GY": "South America",
  "HT": "North America",
  "HM": "Antarctica",
  "VA": "Europe",
  "HN": "North America",
  "HK": "Asia",
  "HU": "Europe",
  "IS": "Europe",
  "IN": "Asia",
  "ID": "Asia",
  "IR": "Asia",
  "IQ": "Asia",
  "IE": "Europe",
  "IM": "Europe",
  "IL": "Asia",
  "IT": "Europe",
  "JM": "North America",
  "JP": "Asia",
  "JE": "Europe",
  "JO": "Asia",
  "KZ": "Asia",
  "KE": "Africa",
  "KI": "Oceania",
  "KP": "Asia",
  "KR": "Asia",
  "KW": "Asia",
  "KG": "Asia",
  "LA": "Asia",
  "LV": "Europe",
  "LB": "Asia",
  "LS": "Africa",
  "LR": "Africa",
  "LY": "Africa",
  "LI": "Europe",
  "LT": "Europe",
  "LU": "Europe",
  "MO": "Asia",
  "MK": "Europe",
  "MG": "Africa",
  "MW": "Africa",
  "MY": "Asia",
  "MV": "Asia",
  "ML": "Africa",
  "MT": "Europe",
  "MH": "Oceania",
  "MQ": "North America",
  "MR": "Africa",
  "MU": "Africa",
  "YT": "Africa",
  "MX": "North America",
  "FM": "Oceania",
  "MD": "Europe",
  "MC": "Europe",
  "MN": "Asia",
  "ME": "Europe",
  "MS": "North America",
  "MA": "Africa",
  "MZ": "Africa",
  "MM": "Asia",
  "NA": "Africa",
  "NR": "Oceania",
  "NP": "Asia",
  "NL": "Europe",
  "NC": "Oceania",
  "NZ": "Oceania",
  "NI": "North America",
  "NE": "Africa",
  "NG": "Africa",
  "NU": "Oceania",
  "NF": "Oceania",
  "MP": "Oceania",
  "NO": "Europe",
  "OM": "Asia",
  "PK": "Asia",
  "PW": "Oceania",
  "PS": "Asia",
  "PA": "North America",
  "PG": "Oceania",
  "PY": "South America",
  "PE": "South America",
  "PH": "Asia",
  "PN": "Oceania",
  "PL": "Europe",
  "PT": "Europe",
  "PR": "North America",
  "QA": "Asia",
  "RE": "Africa",
  "RO": "Europe",
  "RU": "Europe", // Note: Russia spans both continents; adjust if needed
  "RW": "Africa",
  "BL": "North America",
  "SH": "Africa",
  "KN": "North America",
  "LC": "North America",
  "MF": "North America",
  "PM": "North America",
  "VC": "North America",
  "WS": "Oceania",
  "SM": "Europe",
  "ST": "Africa",
  "SA": "Asia",
  "SN": "Africa",
  "RS": "Europe",
  "SC": "Africa",
  "SL": "Africa",
  "SG": "Asia",
  "SX": "North America",
  "SK": "Europe",
  "SI": "Europe",
  "SB": "Oceania",
  "SO": "Africa",
  "ZA": "Africa",
  "GS": "Antarctica",
  "SS": "Africa",
  "ES": "Europe",
  "LK": "Asia",
  "SD": "Africa",
  "SR": "South America",
  "SJ": "Europe",
  "SE": "Europe",
  "CH": "Europe",
  "SY": "Asia",
  "TW": "Asia",
  "TJ": "Asia",
  "TZ": "Africa",
  "TH": "Asia",
  "TL": "Asia",
  "TG": "Africa",
  "TK": "Oceania",
  "TO": "Oceania",
  "TT": "North America",
  "TN": "Africa",
  "TR": "Asia", // Turkey is transcontinental; adjust as necessary
  "TM": "Asia",
  "TC": "North America",
  "TV": "Oceania",
  "UG": "Africa",
  "UA": "Europe",
  "AE": "Asia",
  "GB": "Europe",
  "US": "North America",
  "UM": "Oceania",
  "UY": "South America",
  "UZ": "Asia",
  "VU": "Oceania",
  "VE": "South America",
  "VN": "Asia",
  "VG": "North America",
  "VI": "North America",
  "WF": "Oceania",
  "EH": "Africa",
  "YE": "Asia",
  "ZM": "Africa",
  "ZW": "Africa"
};

export const CUSTOM_REGION_COUNTRIES = {
  'Africa': [
    "DZ", "AO", "BJ", "BW", "BF", "BI", "CV", "CM", "CF", "TD", "KM", "CG", "CD",
    "CI", "DJ", "EG", "GQ", "ER", "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "KE",
    "LS", "LR", "LY", "MG", "MW", "ML", "MR", "MU", "YT", "MA", "MZ", "NA", "NE",
    "NG", "RE", "RW", "SH", "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "TZ",
    "TG", "TN", "UG", "EH", "ZM", "ZW"
  ],
  'Caribbean': [
    "AG", "BS", "BB", "CU", "DM", "DO", "GD", "HT", "JM", "KN", "LC", "MF", "VC",
    "TT", "SX", "VG", "VI"
  ],
  'Central America': [
    "BZ", "CR", "SV", "GT", "HN", "NI", "PA"
  ],
  'Central Asia': [
    "KZ", "KG", "TJ", "TM", "UZ"
  ],
  'Europe': [
    "AX", "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ", "DK", "EE",
    "FO", "FI", "FR", "DE", "GI", "GR", "GG", "HU", "IS", "IE", "IM", "IT", "JE",
    "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "NO", "PL", "PT", "RO",
    "RU", "SM", "RS", "SK", "SI", "ES", "SJ", "SE", "CH", "UA", "GB", "VA"
  ],
  'Middle East': [
    "BH", "IR", "IQ", "IL", "JO", "KW", "LB", "OM", "PS", "QA", "SA", "SY", "AE", "YE"
  ],
  'North America': [
    "AI", "AW", "BM", "CA", "KY", "CW", "GL", "MQ", "MX", "PM", "PR", "BL", "TC",
    "US", "BZ"
  ],
  'Oceania': [
    "AS", "AU", "CX", "CC", "CK", "FJ", "GU", "KI", "MH", "FM", "NR", "NC", "NZ",
    "NU", "NF", "MP", "PW", "PG", "PN", "SB", "TK", "TO", "TV", "VU", "WF", "WS"
  ],
  'South America': [
    "AR", "BO", "BR", "CL", "CO", "EC", "FK", "GF", "GY", "PY", "PE", "SR", "UY", "VE"
  ],
  'South East Asia': [
    "BN", "KH", "ID", "LA", "MY", "MM", "PH", "SG", "TH", "TL", "VN"
  ],
  'Asia': [
    "AF", "AM", "AZ", "BD", "BT", "BN", "KH", "CN", "GE", "HK", "IN", "ID", "IR",
    "IQ", "IL", "JP", "JO", "KZ", "KW", "KG", "LA", "LB", "MO", "MY", "MV", "MN",
    "MM", "NP", "KP", "KR", "OM", "PK", "PH", "QA", "SA", "SG", "LK", "SY", "TW",
    "TJ", "TH", "TL", "TM", "TR", "AE", "UZ", "VN", "YE"
  ],
  'Antarctica': [
    "AQ", "BV", "TF", "HM", "GS"
  ]
};


export const NON_COUNTRY_REGIONS = [
  // regions
  'Africa',
  'Caribbean',
  'Central America',
  'Central Asia',
  'Europe',
  'Middle East',
  'North America',
  'Oceania',
  'South America',
  'South East Asia',
  'Asia',
  'Antarctica',
  // pages
  'About',
  // 'Privacy Policy',
  'Terms of Service',
]
